export class StringHelper {
  /**
   * Replace all the ocurrences in the given string
   * by replace string
   * @param value String to replace
   * @param pattern Regex Pattern
   * @param replaceValue New value
   * @returns New string with values replaced
   */
  public static replaceAll(value: string, pattern: RegExp, replaceValue: string): string {
    const regex = new RegExp(pattern, "g");
    return value.replace(regex, replaceValue);
  }

  /**
   * Convert string to pascal case and replace hyphens by
   * spaces
   * @param value string to convert
   * @returns Given string in pascal case
   * @example value: ready-for-export -> Ready For Export
   */
  public static convertToHumanReadableText(value: string): string {
    const valueWithoutHyphens = StringHelper.replaceAll(value, /-/, " ");
    const regex = new RegExp(/(\w)(\w*)/g);

    return valueWithoutHyphens.replace(regex, function (group0, group1, group2) {
      return group1.toUpperCase() + group2.toLowerCase();
    });
  }

  /**
   * Capitalizes the first letter of a string
   * @param str The string
   * @returns The capitalized string
   */
  public static capitalizeFirstLetter(str: string): string {
    if (!str) {
      return str;
    }

    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /**
   * Converts path to RegExp
   * @param path The path to convert
   * @returns The RegExp of the path
   */
  public static pathToRegex(path: string): RegExp {
    const PATH_PARAM_PATTERN = /:[\w]+/g; // matches :paramName
    const URL_SEGMENT_REGEX = "[^/]+"; // matches a single path segment

    const regex = new RegExp(`^${path.replace(PATH_PARAM_PATTERN, URL_SEGMENT_REGEX)}$`);

    return regex;
  }

  /**
   * Normalizes text by replacing underscores with spaces and converting to sentence case
   * (only the first letter of the first word is capitalized)
   * @param text The text to normalize
   * @returns Normalized text in sentence case
   * @example "HIGHLY_CONFIDENTIAL" -> "Highly confidential"
   * @example "NOT_STARTED" -> "Not started"
   * @example "APPROVED" -> "Approved"
   */
  public static normalizeText(text: string): string {
    if (!text) {
      return text;
    }

    // Replace underscores with spaces and convert to lowercase
    const normalized = text.replace(/_/g, " ").toLowerCase();

    // Capitalize only the first letter
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  }
}
